import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { baseURL, PORTFOLIO } from "../../../Api/Api";
import { Axios } from "../../../Api/axios";
import Header from "../Header/Header";
import Main from "../Main/Main";
import Footer from "../Footer/Footer";
import { useTranslation } from "react-i18next";
import "./Portfolio.css";
function PortfolioProjectDetail() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t, i18n } = useTranslation(); // Get the current language

  useEffect(() => {
    Axios.get(`${baseURL}/${PORTFOLIO}/view/${id}`)
      .then((res) => {
        setProject(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching project:", err);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!project) return <p>Project not found.</p>;

  return (
    <>
      <Header />
      <Main>
        {/* Page Title */}
        <div className="page-title">
          <div className="heading">
            <div className="container">
              <div className="row d-flex justify-content-center text-center">
                <div className="col-lg-8">
                  <h1
                    style={{ color: "#198754", textAlign: "center" }}
                    className={
                      i18n.language === "ar" ? "arabic-font" : "english-font"
                    }
                  >
                    {i18n.language === "ar"
                      ? project.title_ar
                      : project.title_en}
                  </h1>
                  <p className="mb-0">
                    {i18n.language === "ar" ? project.desc_ar : project.desc_en}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <nav className="breadcrumbs">
            <div className="container">
              <ol>
                <li>
                  <a href="/" style={{ color: "#198754" }}>
                    {t("home")}
                  </a>
                </li>
                <li className="current">
                  {i18n.language === "ar" ? project.title_ar : project.title_en}
                </li>
              </ol>
            </div>
          </nav>
        </div>

        {/* Portfolio Details */}
        <section id="portfolio-details" className="portfolio-details section">
          <div className="container">
            <div className="row gy-4">
              {/* Swiper Slider */}
              <div className="col-lg-8" dir={"ltr"}>
                <Swiper
                  modules={[Pagination, Autoplay]}
                  loop={true}
                  speed={600}
                  autoplay={{ delay: 5000 }}
                  slidesPerView={1}
                  pagination={{ clickable: true }}
                >
                  {project.images
                    ?.filter((image) => image.is_background === 0)
                    .map((image) => (
                      <SwiperSlide key={image.id}>
                        <img
                          src={image.path}
                          alt={`Project ${image.id}`}
                          style={{ width: "100%", borderRadius: "10px" }}
                        />
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>

              {/* Project Info */}
              <div className="col-lg-4">
                <div className="portfolio-info">
                  <h3
                    style={{ color: "#198754" }}
                    className={
                      i18n.language === "ar" ? "arabic-font" : "english-font"
                    }
                  >
                    {i18n.language === "ar"
                      ? "معلومات المشروع"
                      : "Project Information"}
                  </h3>
                  <ul>
                    <li>
                      <strong>
                        {i18n.language === "ar" ? "العميل: " : "Client: "}
                      </strong>
                      {i18n.language === "ar"
                        ? project.client?.title_ar
                        : project.client?.title_en}
                    </li>
                    <li>
                      <strong>
                        {i18n.language === "ar" ? "الفئة: " : "Tag: "}
                      </strong>
                      {i18n.language === "ar"
                        ? project.tag?.name_ar
                        : project.tag?.name_en}
                    </li>
                    <li>
                      <strong>
                        {i18n.language === "ar"
                          ? "تاريخ بداية المشروع: "
                          : "Start Date: "}
                      </strong>
                      {project.start_date}
                    </li>
                  </ul>
                </div>
                <div className="portfolio-description">
                  <h3
                    style={{ color: "#198754", fontWeight: "bold" }}
                    className={
                      i18n.language === "ar" ? "arabic-font" : "english-font"
                    }
                  >
                    {i18n.language === "ar"
                      ? "المزيد عن هذا المشروع"
                      : "More About This Project"}
                  </h3>

                  <p>
                    {i18n.language === "ar" ? project.desc_ar : project.desc_en}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Main>
      <Footer />
    </>
  );
}

export default PortfolioProjectDetail;
